export default function trapFocus(container: HTMLElement) {
    const focusableElements = container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
  
    const first = focusableElements[0] as HTMLElement;
    const last = focusableElements[focusableElements.length - 1] as HTMLElement;
    
    // Get the appropriate activeElement reference for Shadow DOM
    const getActiveElement = (): Element | null => {
      const rootNode = container.getRootNode();
      if (rootNode instanceof ShadowRoot) {
        return rootNode.activeElement;
      }
      return document.activeElement;
    };
    
    container.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        const activeElement = getActiveElement();
        if (e.shiftKey) { // Shift + Tab
          if (activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else { // Tab only
          if (activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    });
  }
  